import { useState } from "react";
import { useChecklists } from "./useChecklists";
import ChecklistsQuickViewPanel from "./ChecklistsQuickViewPanel";
import ChecklistsModal from "../../checklists/ChecklistsModal";

const ChecklistsQuickView = ({ patientId }: { patientId: number }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const patientChecklist = useChecklists({ patientId });

	const isLoading = patientChecklist.isLoading;
	const isError = patientChecklist.isError;

	return (
		<>
			<ChecklistsQuickViewPanel
				isLoading={isLoading}
				isError={isError}
				checkLists={patientChecklist.data}
				onClickAction={() => setIsModalOpen(true)}
			/>
			{isModalOpen && (
				<ChecklistsModal
					patientId={patientId}
					isVisible={isModalOpen}
					checkLists={patientChecklist.data}
					closeModal={() => setIsModalOpen(false)}
				/>
			)}
		</>
	);
};

export default ChecklistsQuickView;
